import React, { useState, useEffect } from 'react';
import { Card, Grid, makeStyles, Typography, useTheme } from '@material-ui/core';
import { BarChart, Bar, Cell, XAxis, YAxis, CartesianGrid, Tooltip, Legend, ResponsiveContainer } from 'recharts';
import { blue, blueGrey, deepPurple, teal } from '@material-ui/core/colors';
import { useMediaQuery } from '@material-ui/core';
import TransactionModal from './TransactionModal';

const chart_size_lg = 200
const chart_size_md = 120


const StackBarTransactions = ({transactions, data, catalogs}) => {

    const classes = useStyles()
    const theme = useTheme()
    const [active_index, setActiveIndex] = useState(0)
    const is_medium = useMediaQuery(theme.breakpoints.only('md'))
    const [modal, setModal] = useState(false)
    const [filter_transactions, setFilterTransactions] = useState([])
    
    const onMouserEnter = (_, index) => {
        setActiveIndex(index)
    }


    const chart_size = is_medium ? chart_size_md : chart_size_lg
    const innerData = JSON.parse(JSON.stringify(data))

    /*useEffect(() => {
        const bar = {location_id:1, group_id:1}
        let _filtered_transactions = []
        transactions.forEach(item => {
            if(bar.location_id === item.idMerchant && bar.group_id === item.idGroup) _filtered_transactions.push(item)
        })
        setFilterTransactions(_filtered_transactions)
    }, [transactions])*/

    const onInnerBarClick = (bar, i) => {
        console.log(bar)
        //console.log(transactions)
        let _filtered_transactions = []
        transactions.forEach(item => {
            if(bar.location_id === item.idMerchant && bar.group_id === item.idGroup) _filtered_transactions.push(item)
        })
        setFilterTransactions(_filtered_transactions)
        setModal(true)
    }

    const onCloseModal = () => {
        setModal(false)
        setFilterTransactions([])
    }

    const total = 93

    return ( 
        <Card className={classes.card}>
            <TransactionModal open={modal} onClose={onCloseModal} transactions={filter_transactions} />
            <div className={classes.container}>
                <Grid container spacing={2}>
                    <Grid item xs={12}>
                        <Typography variant='subtitle1'>Transaction's details</Typography>
                    </Grid>
                    <Grid item xs={12}>
                        <div style={{ width: '100%', height: 500 }}>
                            <ResponsiveContainer>
                                <BarChart
                                    data={innerData}>
                                    <CartesianGrid strokeDasharray="3 3" />
                                    <XAxis dataKey="name" tick={{fontSize:12}} interval={0} angle={45} textAnchor='start' height={150} />
                                    <YAxis />
                                    <Tooltip />
                                    <Legend />
                                    <Bar dataKey="casino" stackId="a" fill={deepPurple[700]} onClick={onInnerBarClick} />
                                    <Bar dataKey="mastercard" stackId="a" fill={blue[900]} onClick={onInnerBarClick} />
                                    <Bar dataKey="activations" stackId="a" fill={teal[700]} onClick={onInnerBarClick} />
                                </BarChart>
                            </ResponsiveContainer>
                        </div>
                    </Grid>
                </Grid>
            </div>
        </Card>

     );
}

const useStyles = makeStyles(theme => ({
    card:{
        boxShadow:'rgba(149, 157, 165, 0.2) 0px 8px 24px',
        borderRadius:8,
        
    },
    container:{
        padding:20,
        paddingBottom:30,
        height:'100%'
    },
    graph_content:{
        width:chart_size_lg,
        height:chart_size_lg,
        position:'relative',
        margin:'auto',
        [theme.breakpoints.only('md')]:{
            width:chart_size_md,
            height:chart_size_md,
        }
    },
    graph:{
        position:'absolute',
        width:'100%',
        height:'100%',
        top:0, left:0,
    },
    number:{
        color:blueGrey[900],
        fontSize:'2.5rem',
        lineHeight:1,
        fontWeight:600
    },
    quantity:{
        position:'absolute',
        top:'50%', left:'50%',
        transform:'translate(-50%, -50%)'
    }
}))
 
export default StackBarTransactions;